module.exports = __webpack_public_path__ + "static/media/portfoliobanner-extra-img-right.8efc3ea3.png";